export default "__VITE_ASSET__BFr6$fnJ__"